// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner-module--banner--3VQVx","img":"Banner-module--img--32cMv","caption":"Banner-module--caption--3iKpe"};